import { Check } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { InfoTip } from "@/components/app/Help";

const slug = (s) => String(s).toLowerCase().replace(/\W+/g, "-");

export const Q = ({ label, req, hint, tip, children }) => (
  <div className="space-y-1.5">
    <Label className="flex items-center gap-1 text-sm text-slate-800">{label}{req ? <span className="text-rose-500" title="Mandatory">*</span> : <span className="text-[10px] font-normal text-slate-400">(optional)</span>}{tip && <InfoTip text={tip} />}</Label>
    {children}{hint && <p className="text-[11px] text-slate-500">{hint}</p>}
  </div>
);

export const Choice = ({ value, onChange, options = ["Yes", "No", "Not sure"], id }) => (
  <div className="flex flex-wrap gap-1.5" role="radiogroup">
    {options.map((o) => (
      <button key={o} type="button" role="radio" aria-checked={value === o} onClick={() => onChange(o)} data-testid={`${id}-${slug(o)}`}
        className={`rounded-md border px-3 py-1.5 text-sm transition-colors ${value === o ? "border-blue-600 bg-blue-600 text-white" : "border-slate-200 bg-white text-slate-700 hover:border-blue-300"}`}>{o}</button>))}
  </div>
);

export const Multi = ({ value = [], onChange, options, id }) => (
  <div className="grid gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
    {options.map((o) => { const on = value.includes(o); return (
      <button key={o} type="button" aria-pressed={on} onClick={() => onChange(on ? value.filter((x) => x !== o) : [...value, o])} data-testid={`${id}-${slug(o)}`}
        className={`flex items-center gap-2 rounded-md border px-2.5 py-1.5 text-left text-xs transition-colors ${on ? "border-blue-500 bg-blue-50 text-blue-800" : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"}`}>
        <span className={`grid h-3.5 w-3.5 shrink-0 place-items-center rounded border ${on ? "border-blue-600 bg-blue-600" : "border-slate-300"}`}>{on && <Check className="h-2.5 w-2.5 text-white" />}</span>{o}</button>); })}
  </div>
);

export const Txt = ({ value, onChange, id, area, placeholder }) => (area
  ? <Textarea rows={2} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={id} />
  : <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={id} />);

export const Pick = ({ value, onChange, options, id }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger data-testid={id}><SelectValue placeholder="Select…" /></SelectTrigger>
    <SelectContent>{options.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
  </Select>
);
